let _count = 0

export function lockBodyScroll () {
  _count++
  if (_count === 1) document.body.classList.add('modal-open')
}

export function unlockBodyScroll () {
  _count = Math.max(0, _count - 1)
  if (_count === 0) document.body.classList.remove('modal-open')
}
